export const adEditorCancelButton = {
  color: '#E37D7A',
  fontSize: 16,
  fontWeight: '600',
  textDecoration: 'underline',
  '&:hover': {
    cursor: 'pointer',
    color: '#E37D7A'
  }
};
